/**
 * The GraphQL errors the server answered an operation with, or an empty array when the failure was
 * something else — the request never arrived, the response would not parse, there is no error.
 *
 * Today this reads `graphQLErrors`. Apollo Client 4 deletes `ApolloError` and moves the same errors
 * onto `CombinedGraphQLErrors.errors`, so at the bump this one expression changes and no call site
 * does. This comment is the only marker on that line: the facade is exempt from
 * `local-rules/no-apollo-v4-removed-exports`, so nothing else will point at it.
 *
 * They are typed as `GraphQLFormattedError` rather than v3's `GraphQLError` class so that no call
 * site comes to depend on a field the formatted shape does not carry.
 *
 * It takes `unknown` because an error caught from a rejected mutation arrives untyped, and the
 * `Array.isArray` guard makes the empty-array answer true for every value that admits. The cost is
 * that passing the wrong thing — a result rather than its error — compiles and answers "none".
 */
export const getGraphQLErrors = (error) => {
    const graphQLErrors = error === null || error === void 0 ? void 0 : error.graphQLErrors;
    return Array.isArray(graphQLErrors) ? graphQLErrors : [];
};
